import { GetStaticProps } from 'next';
import configureSentryScope from '../helpers/configureSentryScope';
import getAnnouncementPageViewModels from '../helpers/getAnnouncementPageViewModels';
import AnnouncementPage from '../components/AnnouncementPage/AnnouncementPage';
import expandMarkdownSnippets from '../helpers/expandMarkdownSnippets';
import { getPlaiceholder } from 'plaiceholder';
import convertImageUrlToS3ImageUrl from '../helpers/convertImageUrlToS3ImageUrl';
import buildComponentViewModelsFromEnhancedMarkdowns from '../helpers/buildComponentViewModelsFromEnhancedMarkdowns';

export const AnnouncementPagePath = '/announcement';

export default AnnouncementPage;

export const getStaticProps: GetStaticProps = async ({ params }) => {
  configureSentryScope(params);

  const pageViewModels = await getAnnouncementPageViewModels();

  pageViewModels.announcementPage.body = await expandMarkdownSnippets(
    pageViewModels.announcementPage.body
  );

  const componentViewModels =
    await buildComponentViewModelsFromEnhancedMarkdowns(
      [pageViewModels.announcementPage.body],
      {
        getPlaiceholder: async (src: string) =>
          await getPlaiceholder(convertImageUrlToS3ImageUrl(src)),
      }
    );

  return {
    props: {
      googleAnalytics: pageViewModels.googleAnalytics,
      header: pageViewModels.header,
      footer: pageViewModels.footer,
      page: pageViewModels.announcementPage,
      viewModels: componentViewModels,
    },
    revalidate: 600,
  };
};
